import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import { Link, Navigate, useLocation } from "react-router-dom";
import { navigate } from "@reach/router";
import Axios from 'axios';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';
import { numberWithSpaces } from '../utilities/OtherUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';

// import assets
import btn_back_gray from '../assets/btn_back_gray.png';
import icon_expand from '../assets/icon_expand.png';

class SubmissionDetail extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
            mainSubmissionsId: 0,
            categoryTypes: ([]),
            categoryTypesValues: ([]),
            categoryTypesValuesPrevSubm: ([]),
            globalIsOpen: true,
            nt_org_id: 0,
            natOrgLabel: "Loading",
            period_id: 0,
            periodLabel: "Loading",
            stmt_tp_id: 0,
            statementTypeLabel: "Loading",
            currency_id: 0,
            currencyLabel: "...",
            savedDocument: "",
            prev_subm_id: 0,
        }
    }

    componentDidMount(){
        this.setState({ redirectTo: null });
        //this.setActualSection("submissions");

        this.loadData();
    }

    loadData = async () => {

        const pathname = this.props.location.pathname;
        var id = pathname.substring(pathname.lastIndexOf("/")+1);
        if(id.includes("?")){ id = id.substring(0, id.indexOf("?")); }
        if(Number.isInteger(Number(id))){
            this.setState({ mainSubmissionsId: parseInt(id) });

            Axios.get('/api/subm/get/'+id).then(response => {
                if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

                this.setState({ nt_org_id: response.data.result[0].nt_org_id });
                this.setState({ period_id: response.data.result[0].period_id });
                this.setState({ stmt_tp_id: response.data.result[0].stmt_tp_id });
                this.setState({ currency_id: response.data.result[0].ccy_id });
                if(response.data.result[0].prev_subm_id){
                    // if there is submission from previous year, then load the values
                    this.setState({ prev_subm_id: response.data.result[0].prev_subm_id });
                    var statement_type_id = response.data.result[0].stmt_tp_id;

                    Axios.get('/api/subm_item/get?subm_id='+response.data.result[0].prev_subm_id).then(response => {
                        if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
                        this.setState({ categoryTypesValuesPrevSubm: response.data.result });
                        this.loadCategoryTypes(statement_type_id);
                    });
                }

                this.loadNatOrgLabel(response.data.result[0].nt_org_id);
                this.loadPeriodLabel(response.data.result[0].period_id);
                this.loadStatementTypeName(response.data.result[0].stmt_tp_id);
                this.loadCurrencyName(response.data.result[0].ccy_id);

                // those data are now loading from /api/subm_item/get?subm_id=ID?
                //this.setState({ categoryTypesValues: response.data.result });

                //alert(JSON.stringify(response.data.result[0]));

                // now when I know the stmt_tp_id I need to load all categories for this type
                // then I would go through "categoryTypes" array and replace values from "categoryTypesValues"
                this.loadCategoryTypes(response.data.result[0].stmt_tp_id);
            });

            Axios.get('/api/subm_item/get?subm_id='+id).then(response => {
                if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
                this.setState({ categoryTypesValues: response.data.result });
            });

            Axios.get('/api/file/load?subm_id='+id+"&file_prefix=subm").then(response => {
                //if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
                if(response.data.stat && response.data.stat == "ERR"){
                    // document was not loaded - probably was not uploaded for this submission
                }
                else {
                    this.setState({ savedDocument: response.data });
                }
            });
        }
    }

    loadCategoryTypes = async (stmt_tp_id) => {
        Axios.get('/api/ctg/get').then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ categoryTypes: [] });
            var categoryTypesList = response.data.result;

            // filter just categories for specific statement type
            categoryTypesList = categoryTypesList.filter(item => item.stmt_tp_id == stmt_tp_id);

            categoryTypesList = categoryTypesList.map(item => {
                return {
                    ...item,
                    amount_prev_year: this.getPrevAmtByCtgId(item.id),
                    amt: this.getAmtByCtgId(item.id),
                    cmnt: this.getCmntByCtgId(item.id),
                    expl: this.getExplByCtgId(item.id),
                    is_open: true,
                }
            });

            this.setState({ categoryTypes: categoryTypesList });
        });
    }

    getPrevAmtByCtgId(ctg_id) {
        for(let oneRow of this.state.categoryTypesValuesPrevSubm){
           if(oneRow.ctg_id == ctg_id && Number.isInteger(Number(oneRow.amt)))return parseInt(oneRow.amt);
        }
        return 0;
    }

    getAmtByCtgId(ctg_id) {
        for(let oneRow of this.state.categoryTypesValues){
           if(oneRow.ctg_id == ctg_id && Number.isInteger(Number(oneRow.amt)))return parseInt(oneRow.amt);
        }
        return 0;
    }

    getCmntByCtgId = (ctg_id) => {
        for(let oneRow of this.state.categoryTypesValues){
            if(oneRow.ctg_id == ctg_id)return oneRow.cmnt;
        }
        return "";
    }

    getExplByCtgId = (ctg_id) => {
        for(let oneRow of this.state.categoryTypesValues){
            if(oneRow.ctg_id == ctg_id && true)return oneRow.expl;
        }
        return "";
    }

    loadNatOrgLabel = (nt_org_id) => {
        Axios.get('/api/nt_org/get').then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            for(let oneRow of response.data.result){
                if(oneRow.id == nt_org_id){
                    this.setState({ natOrgLabel: oneRow.label});
                    return;
                }
            }
            this.setState({ natOrgLabel: "Error"});
            return;
        });
    }

    loadPeriodLabel = (period_id) => {
        Axios.get('/api/period/get').then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            for(let oneRow of response.data.result){
                if(oneRow.id == period_id){
                    this.setState({ periodLabel: oneRow.label});
                    return;
                }
            }
            this.setState({ periodLabel: "Error"});
            return;
        });
    }

    loadStatementTypeName = (stmt_tp_id) => {
        Axios.get('/api/stmt_tp/get').then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            for(let oneRow of response.data.result){
                if(oneRow.id == stmt_tp_id){
                    this.setState({ statementTypeLabel: oneRow.label});
                    return;
                }
            }
            this.setState({ statementTypeLabel: "Error"});
            return;
        });
    }

    loadCurrencyName = (ccy_id) => {
        Axios.get('/api/ccy/get').then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            for(let oneRow of response.data.result){
                if(oneRow.id == ccy_id){
                    this.setState({ currencyLabel: oneRow.iso_code});
                    return;
                }
            }
            this.setState({ currencyLabel: "Error"});
            return;
        });
    }

    onIsOpenChanged = (newValue, idCategory) => {
        var newArray = this.state.categoryTypes;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.is_open = newValue; } }
        this.setState({ categoryTypes: newArray})
    }

    onGlobalIsOpenChanged = () => {
        var newArray = this.state.categoryTypes;
        for(let oneRow of newArray){ oneRow.is_open = !this.state.globalIsOpen; }

        this.setState({ categoryTypes: newArray});
        this.setState({ globalIsOpen: !this.state.globalIsOpen});
    }

    hasChild = (idCategory) => {
        for(let oneRow of this.state.categoryTypes){
            if(oneRow.parent_id == idCategory) return true;
        }
        return false;
    }

    openEditPage = () => {
        // EditSubmission
        const pathname = this.props.location.pathname;
        var id = pathname.substring(pathname.lastIndexOf("/")+1);
        if(id.includes("?")){ id = id.substring(0, id.indexOf("?")); }

        if(Number.isInteger(Number(id))) this.setState({ redirectTo: "/EditSubmission/"+id });
        else this.props.openAlertMessageTwoActions("Some error happened.","Close","",null);
    }

    deleteSubmission = () => {
        Axios.delete('/api/subm/del/'+this.state.mainSubmissionsId, {
        }).then((response) => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ redirectTo: "/Submissions" });
        });
    }

    askToDeleteSubmission = () => {
        this.props.openAlertMessageTwoActions("Are you sure, you want to delete this submission?","No","Yes",this.deleteSubmission);
    }


    showDocument = async () => {
        const pdfstr = await fetch(this.state.savedDocument);
        const blobFromFetch= await pdfstr.blob();

        var blob = new Blob([blobFromFetch], {type: "application/pdf"});
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl,"_blank");
    };

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />
        }
        return(
                <div className="verticalStack flex" style={{height: "calc(100vh - 80px)", overflowY: "scroll"}}>
                    <div className="horizontalStackCenter universalTableListingBar">
                        <div className="horizontalStackCenter onHoverToOrange clickable" onClick={() => this.setState({ redirectTo: -1 })}>
                            <img src={btn_back_gray} style={{height: 14, marginRight: 7}} />
                            <span className="fontPoppinsRegular13Gray" style={{whiteSpace: "nowrap"}}>{"Return to Previous Page"}</span>
                        </div>
                    </div>

                    <div className="horizontalStack">

                        <div className="verticalStack flex">

                            <div className="universalTile" style={{marginLeft: 20, marginRight: 10}}>
                                <div className="horizontalStack">

                                    <div className="verticalStack">
                                        <span className="fontPoppinsSemiBold15">Submission</span>
                                        <span className="fontPoppinsRegular13DarkGray" style={{marginTop: 10}}>Statement type: <span className="fontPoppinsRegular13Gray">{this.state.statementTypeLabel}</span></span>
                                        <span className="fontPoppinsRegular13DarkGray">National organization: <span className="fontPoppinsRegular13Gray">{this.state.natOrgLabel}</span></span>
                                        <span className="fontPoppinsRegular13DarkGray">Year: <span className="fontPoppinsRegular13Gray">{this.state.periodLabel}</span></span>
                                        <span className="fontPoppinsRegular13DarkGray">Currency: <span className="fontPoppinsRegular13Gray">{this.state.currencyLabel}</span></span>

                                        {this.state.savedDocument == "" ? <span className="fontPoppinsRegular13DarkGray">Document: <span className="fontPoppinsRegular13Gray">not saved</span></span> : null }
                                        {this.state.savedDocument != "" ? <span className="fontPoppinsRegular13DarkGray">Document: <span className="fontPoppinsRegular13Gray textLinkHover clickable" onClick={this.showDocument}>open</span><a download={"submission_"+this.state.natOrgLabel+"_"+this.state.periodLabel} href={this.state.savedDocument} style={{marginLeft: 10}}><span className="fontPoppinsRegular13Gray textLinkHover">download</span></a></span> : null }

                                    </div>

                                    <div className="flex"/>

                                    <div className="horizontalStack">
                                        <RoundButton title={"Edit"} onClick={this.openEditPage} whiteText={false} />
                                        <div style={{width: 20, height: 20}}></div>
                                        <RoundButton title={"Delete"} onClick={this.askToDeleteSubmission} whiteText={false} />
                                    </div>

                                </div>

                            </div>

                            {/* SECOND TILE */}

                            <div className="universalLeftTileWithTable" style={{marginTop: 20, marginBottom: 20}}>

                                    <div className="horizontalStackCenter">

                                            <table className="universalTableInLeftTile" style={{marginTop: 10}}>
                                                <tr>
                                                    <td className="universalTableInLeftTileHeader clickable" nowrap="nowrap" style={{minWidth: 200}} onClick={() => this.onGlobalIsOpenChanged()}>
                                                        <div>
                                                            <img className={this.state.globalIsOpen ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px", marginRight: 10}} src={icon_expand}/>
                                                            Category
                                                        </div>
                                                    </td>
                                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap">Previous Year</td>
                                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap">Current Year</td>
                                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{width: "50%"}}>Amount Explanation</td>
                                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap">Variance</td>
                                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{width: "50%"}}>Variance Explanation</td>
                                                </tr>


                                                {this.state.categoryTypes.map(function (item) {
                                                    if(item.lvl == 1) return (
                                                        <tbody>
                                                        <tr className="clickable" key={item.id} style={{backgroundColor: "var(--gray-blue)"}} className="clickable" onClick={() => this.onIsOpenChanged(!item.is_open,item.id)}>
                                                            <td nowrap="nowrap" style={{padding: 10}}>
                                                                <div className="fontPoppinsRegular15">
                                                                    <img className={item.is_open ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px",marginLeft: 5, marginRight: 10, visibility: this.hasChild(item.id) ? "visible" : "hidden"}} src={icon_expand}/>
                                                                    {item.label}
                                                                </div>
                                                            </td>
                                                            <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                            <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amt)} {this.state.currencyLabel}</span></td>
                                                            <td style={{paddingLeft: 20, paddingRight: 20}}><span className="fontPoppinsRegular13">{item.cmnt}</span></td>
                                                            <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amt - item.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                            <td style={{paddingLeft: 20, paddingRight: 20}}><span className="fontPoppinsRegular13">{item.expl}</span></td>
                                                        </tr>
                                                        <div style={{height: 2}}></div>

                                                        {item.is_open && this.state.categoryTypes.map(function (secondItem) {
                                                            if(secondItem.parent_id == item.id){
                                                                return (
                                                                    <React.Fragment>
                                                                    <tr style={{backgroundColor: "var(--light-blue)"}} className="clickable" onClick={() => this.onIsOpenChanged(!secondItem.is_open,secondItem.id)}>
                                                                        <td style={{padding: 10, fontSize: 13, paddingLeft: 15}} nowrap="nowrap">
                                                                            <div className="fontPoppinsRegular13">
                                                                                <img className={secondItem.is_open ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px", marginLeft: 5, marginRight: 10, visibility: this.hasChild(secondItem.id) ? "visible" : "hidden"}} src={icon_expand}/>
                                                                                {secondItem.label}
                                                                            </div>
                                                                        </td>
                                                                        <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                                        <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amt)} {this.state.currencyLabel}</span></td>
                                                                        <td style={{paddingLeft: 20, paddingRight: 20}}><span className="fontPoppinsRegular13">{secondItem.cmnt}</span></td>
                                                                        <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amt - secondItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                                        <td style={{paddingLeft: 20, paddingRight: 20}}><span className="fontPoppinsRegular13">{secondItem.expl}</span></td>
                                                                    </tr>
                                                                    <div style={{height: 2}}></div>

                                                                    {secondItem.is_open && this.state.categoryTypes.map(function (thirdItem) {
                                                                        if(thirdItem.parent_id == secondItem.id) return (
                                                                            <React.Fragment>
                                                                            <tr style={{backgroundColor: "var(--lightest-blue)"}}>
                                                                                <td style={{padding: 10, fontSize: 13, paddingLeft: 40}}><span className="fontPoppinsRegular13">{thirdItem.label}</span></td>
                                                                                <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                                                <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amt)} {this.state.currencyLabel}</span></td>
                                                                                <td style={{paddingLeft: 20, paddingRight: 20}}><span className="fontPoppinsRegular13">{thirdItem.cmnt}</span></td>
                                                                                <td nowrap="nowrap" style={{textAlign: "center"}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amt - thirdItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                                                <td style={{paddingLeft: 20, paddingRight: 20}}><span className="fontPoppinsRegular13">{thirdItem.expl}</span></td>
                                                                            </tr>
                                                                            <div style={{height: 2}}></div>
                                                                            </React.Fragment>
                                                                        )
                                                                    }.bind(this))}

                                                                    </React.Fragment>
                                                                )


                                                            }
                                                        }.bind(this))}

                                                        </tbody>
                                                    )
                                                }.bind(this))}
                                            </table>

                                    </div>

                            </div>
                        </div>

                    </div>
                </div>
        );
    }
}

const withLocation = Component => props => {
    const location = useLocation();

    return <Component {...props} location={location} />;
};

export default withLocation(SubmissionDetail);